/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { Text } from 'components/Text';
import { Breakpoints } from "constants/Breakpoints";
import Colors from 'constants/Colors';
import styled from 'styled-components';


export const Circle = styled.div` 
  width: 20px; 
  height: 20px;
  border-radius: 100%;
  background: ${Colors.GRAY[0]};
  color: ${Colors.WHITE};
  -moz-transform: scaleY(1);
  -webkit-transform: scaleY(1);
  text-align: center;
  justify-content: center;
  display: inline-flex;
  margin-right: 10px;
  
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const CustomField = styled.div`
  display: inline-flex;
  width: 70%;
  vertical-align: middle;
  
  div{
    min-height: auto;
    margin-bottom: 0px;
    width: 100%;
  }
  .is-approved{
    span{
      color: ${Colors.GRAY[0]};
    }
  }
  .is-disabled{
    span{
      color: ${Colors.GRAY[3]}
    }
  }
  
  @media screen and (min-width: ${Breakpoints.md}) {
    display: unset;
    width: unset;
    vertical-align: unset;
  }
`;

export const InlineLabel = styled(Text)`
  display: inline-flex;
  width: 30%;
  vertical-align: middle;
  padding-right: 5px;
  
  
  font-size: 13px;
  color: ${Colors.GRAY[3]};
  
  @media screen and (min-width: ${Breakpoints.md}) {
    display: none;
  }
`;

export const Line = styled.div`
    width: 100%;
    height: 2px;
    margin: 5px 0;
    background-color: ${Colors.GRAY[4]};
`;

export const Endorsement = styled.div`
    padding-left: 16px;
`;
